import styled from 'styled-components';

export const $Section = styled.section`
  width: 100%;
  min-width: 0;
  margin: 0 0 1.25rem;
  box-sizing: border-box;
`;

export const $SectionTitle = styled.h3`
  margin: 0 0 0.75rem;
  font-size: ${({ theme }) => theme.fonts?.size?.medium ?? '1rem'};
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#111827'};
`;

export const $Timeline = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const $TimelineItem = styled.li`
  position: relative;
  display: grid;
  grid-template-columns: 0.75rem 1fr;
  gap: 0.75rem;
  padding-bottom: 1rem;

  &:last-child {
    padding-bottom: 0;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0.55rem;
    left: 0.28rem;
    bottom: 0;
    width: 2px;
    background: ${({ theme }) => theme.newUI?.variationColors?.light3 ?? '#e2e8f0'};
  }

  &:last-child::before {
    display: none;
  }
`;

export const $TimelineDot = styled.span`
  position: relative;
  z-index: 1;
  width: 0.75rem;
  height: 0.75rem;
  margin-top: 0.2rem;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  box-shadow: 0 0 0 3px
    ${({ theme }) => theme.newUI?.variationColors?.light5 ?? 'rgba(83, 105, 235, 0.12)'};
`;

export const $StepContent = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const $StepLabel = styled.div`
  font-size: ${({ theme }) => theme.fonts?.size?.small ?? '0.875rem'};
  font-weight: ${({ theme }) => theme.fonts?.weight?.mediumFont ?? 500};
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#111827'};
  word-break: break-word;
`;

export const $StepMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.75rem;
  font-size: ${({ theme }) => theme.fonts?.size?.ultraSmall ?? '0.75rem'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#64748b'};
`;

export const $ShowAllButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.75rem;
`;

export const $ShowAllButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-size: ${({ theme }) => theme.fonts?.size?.small ?? '0.875rem'};
  font-weight: ${({ theme }) => theme.fonts?.weight?.mediumFont ?? 500};
  color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 0.15rem;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const $DrawerHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const $DrawerBody = styled.div`
  min-width: 0;
`;

export const $EmptyState = styled.div`
  padding: 1rem;
  text-align: center;
  border: 1px dashed ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#cbd5e1'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.mediumRadius ?? '8px'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#64748b'};
  font-size: ${({ theme }) => theme.fonts?.size?.small ?? '0.875rem'};
  background: ${({ theme }) => theme.newUI?.variationColors?.light5 ?? '#f8fafc'};
`;
